<div class="container">

    <div class="row justify-content-center align-items-center taxonomies-creation w-100">
        <section class="col-md-11 col-lg-10 col-xl-8">
            <h1 class="font-bold font-5x">Summary Report</h1>

            <h2 class="font-bold font-4x">Math 6 Scope & Sequence</h2>

            <ng-container>
                <div class="col-12 p-0">
                    <div class="col-12 imported-summary">
                        <div class="row imported-summary--heading">
                            <div class="col-8">
                                <h3 class="font-bold font-3x">Here's a summary of your import</h3>
                            </div>
                        </div>

                        <div class="row align-items-center text-center justify-content-center">
                            <div class="col-3">
                                <div class="row align-items-center" aria-live="polite" aria-atomic="true">
                                    <h4 class="col-12 total font-bold">10</h4>
                                    <p class="col-12 total-info font-bold">Taxonomys <span>Created</span></p>
                                </div>
                            </div>

                            <div class="col-3">
                                <div class="row align-items-center" aria-live="polite" aria-atomic="true">
                                    <h4 class="col-12 total font-bold">25</h4>
                                    <p class="col-12 total-info font-bold">Nodes
                                        <span>Updated</span>
                                    </p>
                                </div>
                            </div>

                            <div class="col-3">
                                <div class="row align-items-center" aria-live="polite" aria-atomic="true">
                                    <h4 class="col-12 total font-bold">25</h4>
                                    <p class="col-12 total-info font-bold">Nodes
                                        <span>Deleted</span>
                                    </p>
                                </div>
                            </div>

                            <div class="col-3">
                                <div class="row align-items-center" aria-live="polite" aria-atomic="true">
                                    <h4 class="col-12 total font-bold">1565</h4>
                                    <p class="col-12 total-info font-bold">New Metadata
                                        <span>Count</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end of imported summary -->
                </div>

                <div class="footer-buttons col-12 d-flex justify-content-center my-3">
                        <button class="btn btn-primary btn-lg" id="closeButton"
                            type="button">Proceed</button></div>
            </ng-container>
        </section>
    </div>
</div>